import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
    : (_openBlock(), _createBlock(_component_v_data_table, {
        key: 1,
        headers: _ctx.headers,
        items: _ctx.statusList,
        density: "compact",
        class: "elevation-1 pre-wrap"
      }, {
        "item.createDate": _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.createDate)), 1)
        ]),
        _: 1
      }, 8, ["headers", "items"]))
}